import React, { useState } from 'react'
import { Card, Form, Button, Alert, Row, Col, Badge } from 'react-bootstrap'
import d_log from 'loglevel'

function MathOperations() {
  const [operationData, setOperationData] = useState({
    a: '',
    b: '',
    operation: 'add'
  })
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [mathInfo, setMathInfo] = useState(null)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setOperationData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const performOperation = async () => {
    setLoading(true)
    setError(null)
    setResult(null)

    try {
      const endpoint = operationData.operation === 'add' ? 'add_numbers' : 'subtract_numbers'
      
      const response = await fetch(`http://localhost:9000/mcp/${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          a: parseFloat(operationData.a),
          b: parseFloat(operationData.b)
        })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      setResult(data)
    } catch (err) {
      setError(`Failed to perform operation: ${err.message}`)
    } finally {
      setLoading(false)
    }
  }

  const fetchMathInfo = async () => {
    try {
      const response = await fetch('http://localhost:3000/mcp/resource/math/info')
      if (response.ok) {
        const info = await response.text()
        setMathInfo(info)
      }
    } catch (err) {
      console.error('Failed to fetch math info:', err)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (operationData.a && operationData.b) {
      performOperation()
    }
  }

  React.useEffect(() => {
    fetchMathInfo()
  }, [])

  return (
    <div>
      <h2>Math Operations</h2>
      <p className="text-muted">Perform basic math operations using the MCP server</p>

      {mathInfo && (
        <Alert variant="info">
          <pre style={{ margin: 0, whiteSpace: 'pre-line' }}>{mathInfo}</pre>
        </Alert>
      )}

      <Row>
        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>Calculate</h5>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>First Number (a)</Form.Label>
                      <Form.Control
                        type="number"
                        step="any"
                        name="a"
                        value={operationData.a}
                        onChange={handleInputChange}
                        placeholder="Enter first number"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Second Number (b)</Form.Label>
                      <Form.Control
                        type="number"
                        step="any"
                        name="b"
                        value={operationData.b}
                        onChange={handleInputChange}
                        placeholder="Enter second number"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>Operation</Form.Label>
                  <Form.Select
                    name="operation"
                    value={operationData.operation}
                    onChange={handleInputChange}
                  >
                    <option value="add">Addition (+)</option>
                    <option value="subtract">Subtraction (-)</option>
                  </Form.Select>
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading || !operationData.a || !operationData.b}
                >
                  {loading ? 'Calculating...' : 'Calculate'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>Result</h5>
            </Card.Header>
            <Card.Body>
              {error && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}

              {result && (
                <div>
                  <div className="mb-3">
                    <Badge bg="success" className="me-2">
                      {result.operation}
                    </Badge>
                  </div>
                  
                  <h4 className="text-primary mb-3">
                    {result.expression}
                  </h4>

                  <Card className="bg-light">
                    <Card.Body>
                      <h6>Operation Details:</h6>
                      <ul className="mb-0">
                        <li><strong>First number:</strong> {result.a}</li>
                        <li><strong>Second number:</strong> {result.b}</li>
                        <li><strong>Result:</strong> {result.result}</li>
                        <li><strong>Operation:</strong> {result.operation}</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              )}

              {!result && !error && !loading && (
                <p className="text-muted">Enter numbers and select an operation to see the result here.</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default MathOperations